module.exports = __webpack_public_path__ + "static/chad-89bf42c47930ea8c00ad7fc4a12b1638.png";